var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-table-column-selector" },
    [
      _c(
        "el-tooltip",
        {
          attrs: { placement: "top", content: _vm.$t("pickColumns.editCols") },
        },
        [
          _c(
            "el-button",
            {
              staticClass: "edit-cols-btn",
              attrs: { type: "info", size: "small" },
              on: {
                click: function ($event) {
                  _vm.isDialogVisible = true
                },
              },
            },
            [
              _c("font-awesome-icon", {
                attrs: { icon: "columns", "aria-hidden": "true", size: "sm" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "column-list-dialog",
          attrs: {
            fullscreen: "",
            title: _vm.$t("pickColumns.pickCols"),
            visible: _vm.isDialogVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isDialogVisible = $event
            },
            close: _vm.saveColumns,
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                "label-position": "top",
                "label-width": "8em",
                inline: true,
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { size: "mini" },
                      on: { change: _vm.handleTemplateChanges },
                      model: {
                        value: _vm.selectedTemplateName,
                        callback: function ($$v) {
                          _vm.selectedTemplateName = $$v
                        },
                        expression: "selectedTemplateName",
                      },
                    },
                    _vm._l(_vm.templateNames, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.title, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.selectedTemplateName === "newTemplate"
                ? _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { size: "mini" },
                        model: {
                          value: _vm.newTemplateName,
                          callback: function ($$v) {
                            _vm.newTemplateName = $$v
                          },
                          expression: "newTemplateName",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.selectedTemplateName === "newTemplate"
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.postNewTemplate()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("pickColumns.newTemplate")) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.helper.isUndefined(_vm.selectedTemplateName) &&
              _vm.selectedTemplateName !== "newTemplate"
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success", size: "mini", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.putCurrentTemplate()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("pickColumns.updateTemplate")) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.helper.isUndefined(_vm.selectedTemplateName) &&
              _vm.selectedTemplateName !== "newTemplate"
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger", size: "mini", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteCurrentTemplate()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("pickColumns.deleteTemplate")) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { type: "flex" } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 12, md: 12 } },
                [
                  _c("div", { staticClass: "col-text" }, [
                    _vm._v(_vm._s(_vm.$t("pickColumns.availableCols"))),
                  ]),
                  _c(
                    "el-card",
                    {
                      staticClass: "column-container",
                      style: { height: _vm.cardInnerHeight },
                    },
                    [
                      _c(
                        "draggable",
                        {
                          staticClass: "dragArea",
                          model: {
                            value: _vm.unselectedColumns,
                            callback: function ($$v) {
                              _vm.unselectedColumns = $$v
                            },
                            expression: "unselectedColumns",
                          },
                        },
                        _vm._l(_vm.unselectedColumns, function (item) {
                          return _c(
                            "div",
                            {
                              key: item,
                              staticClass: "separator cursor-pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.editColumns("add", item)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-caret-right cursor-pointer",
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("planning.columns." + item)) +
                                  " "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 12, md: 12 } },
                [
                  _c("div", { staticClass: "col-text" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("pickColumns.selectedCols")) +
                        " ( " +
                        _vm._s(_vm.$selectedColumns.length) +
                        " / " +
                        _vm._s(
                          _vm.unselectedColumns.length +
                            _vm.$selectedColumns.length
                        ) +
                        " ) "
                    ),
                  ]),
                  _c(
                    "el-card",
                    {
                      staticClass: "column-container",
                      style: { height: _vm.cardInnerHeight },
                    },
                    [
                      _c(
                        "draggable",
                        {
                          staticClass: "dragArea",
                          model: {
                            value: _vm.$selectedColumns,
                            callback: function ($$v) {
                              _vm.$selectedColumns = $$v
                            },
                            expression: "$selectedColumns",
                          },
                        },
                        _vm._l(_vm.$selectedColumns, function (item) {
                          return _c(
                            "div",
                            {
                              key: item,
                              staticClass: "separator cursor-pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.editColumns("remove", item)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-error cursor-pointer",
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("planning.columns." + item)) +
                                  " "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }